<script>
import options from './LotteryForm.options'
export default options
</script>

<template>
  <article class="kb-stafet-donation-flow kb-lottery-form">
    <section v-if="!showResultPage" class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">
      <h1 class="kb-stafet-step__step-section-title">{{ getLabel("lotteryFormTitle") }}</h1>

      <div v-html="getLabel('lotteryFormDescriptionText')"></div>

      <div class="kb-stafet-step__input-wrapper">
        <FormInputDropdown
          isRequired
          v-model="lotteryDropdown"
          fieldName="lotteryDropdown"
          :modelValue="lotteryDropdown"
          :label="getLabel('lotteryRoundDropdownLabel')"
          :isValidationError="displayFormValidationError &&
            !nonEmptyStringValidator(lotteryDropdown)" 
          :placeholder="getLabel('lotteryRoundDropdownPlaceholder')"
          :errorMessageLabel="getLabel('lotteryRoundDropdownError')"
          :selectOptions="lotteryDropdownOptions"
          :onChangeCallback="(e) => (lotteryDropdown = e.target.value)"/>

        <FormInputTextField
          fieldName="controlNumber"
          type="number"
          :modelValue="controlNumber"
          v-model="controlNumber"
          :label="getLabel('controlNumberLabel')"
          :isRequired="true"
          :isValidationError="(displayFormValidationError && !nonEmptyStringValidator(controlNumber)) || displayLotteryTicketError"
          :errorMessageLabel="controlNumberValidationErrorLabel"
          :placeholder="getLabel('controlNumberPlaceholder')"/>
      </div>

      <div class="kb-stafet-step__texts-wrapper">
        <div v-html="getLabel('checkTicketDisclaimer')
          "></div>
      </div>

      <div class="kb-lottery__actions">
        <button class="kb-button kb-button--full-color-spot" :class="{
          'kb-button--disabled': showSpinner
        }" @click="onSubmit">
          {{ getLabel('checkTicketButtonLabel') }}
        </button>
      </div>
    </section>

    <section v-else-if="showResultPage && hasWinnings"
      class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">
      <h1 class="kb-stafet-step__step-section-title">{{ getLabel("winnerTitle") }}</h1>

      <div v-for="ticket in winningTickets" :key="ticket.lotteryTicketId" class="kb-lottery-form__result">
        <h2 class="kb-lottery-form__highlighted">{{ getLabel("reward", [ticket.prize]) }}</h2>
        <p class>{{ getLabel("winnerLotNumber", [ticket.lotteryTicketId]) }}</p>
      </div>

      <div class="kb-stafet-step__texts-wrapper">
        <div v-html="getLabel('WinnerDescriptionText')
          "></div>
      </div>

      <div class="kb-lottery__actions">
        <button class="kb-button kb-button--full-color-spot" @click="clear">
          {{ getLabel('winnerReturnButtonLabel') }}
        </button>
      </div>
    </section>

    <section v-else-if="showResultPage && !hasWinnings"
      class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">
      <h1 class="kb-stafet-step__step-section-title">{{ getLabel("noPrizeTitle") }}</h1>

      <p class="kb-lottery-form">{{ getLabel("noPrizeDescriptionText", [lotteryTickets[0]?.lotteryTicketId]) }}</p>

      <div class="kb-lottery__actions">
        <button class="kb-button kb-button--full-color-spot" @click="clear">
          {{ getLabel('noPrizeReturnButtonLabel') }}
        </button>
      </div>
    </section>

    <div v-if="showSpinner" class="kb-spinner-overlay">
      <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
    </div>
  </article>
</template>
